module.exports = __webpack_public_path__ + "static/media/logo_ABCtopic.e9cda888.webp";